import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import ICalendarLink from "react-icalendar-link";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";

import { allSharedComponents } from "../../../../../shared";
import { authActions, competitionActions } from "../../../../../redux/actions";
import {
  getUserPayload,
  moveBack,
  CommaSplitToTranslatedCommaJoined,
  dateToUTCWithTimezone,
  toSingleDateStringIfEqual,
  serverFormatToMomentObject,
  formatDateTimeRangeFromServer,
} from "../../../../../system";
import {
  DirectionIcon,
  ArrowLeftIcon,
  TimeIcon,
} from "../../../../../assets/images/icon";
import {
  translationConstants,
  systemConstants,
  sportConstants,
  viewPathConstants,
  refreshDispatch,
  Directions,
  timezoneConstants,
  genderEnumReversed,
} from "../../../../../constants";

const { DeleteModal, CustomModal } = allSharedComponents;

const DetailCompetition = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const competitionId = location.state.competitionId;
  const isCancelled = location.state.isCancelled;

  const userPayload = getUserPayload();

  const [city, setCity] = useState();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [isNavigate, setIsNavigate] = useState(false);

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const competitionDataById = useSelector((state) => {
    return state.CompetitionReducer.competitionPublicDataById;
  });
  const isViewModal = useSelector((state) => {
    return state.CompetitionReducer.isViewModal;
  });
  const cities = useSelector((state) => state.LoginReducer.cities);

  const getSportNameById = (id) => {
    const entries = Object.entries(sportConstants);
    const inverted = entries.reduce(
      (obj, [key, value]) => ({ ...obj, [value]: key }),
      {}
    );
    return inverted[id];
  };

  const sportType = getSportNameById(competitionDataById?.sportId);

  const classes = competitionDataById?.classes
    ?.map((boat) => {
      const name =
        direction === Directions.rtl && boat.arabicName
          ? boat.arabicName
          : boat.name;
      const genderText = t(
        translationConstants[genderEnumReversed[boat.gender]]
      );
      return `${name} - ${genderText}`;
    })
    .join(", ");

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
  }, [dispatch, competitionDataById]);

  useEffect(() => {
    const findCity = cities?.find((c) => c.id === competitionDataById?.cityId);
    setCity(findCity);
  }, [cities, competitionDataById]);

  const cancellationData = () => {
    if (competitionDataById?.isPublicRegistrationAllowed) {
      dispatch(
        competitionActions.cancelRegistrationPublic(
          userPayload?.user?.id,
          competitionDataById?.id,
          setIsNavigate,
          refreshDispatch.MY_COMPETITION
        )
      );
    } else {
      dispatch(
        competitionActions.cancelRegistrationPrivate(
          userPayload?.user?.id,
          competitionDataById?.id,
          setIsNavigate,
          refreshDispatch.MY_COMPETITION
        )
      );
    }

    dispatch(competitionActions.toggleViewModal(!isViewModal));
  };

  useEffect(() => {
    if (isNavigate) {
      navigate(`${viewPathConstants.My_COMPETITIONS}`);
    }
  }, [isNavigate]);

  const onDelete = () => {
    setTitle(
      competitionDataById?.isPublicRegistrationAllowed
        ? t(translationConstants.CANCEL_COMPETITION_REGISTRATION)
        : t(translationConstants.CANCEL_INVITE)
    );
    setMessage(
      `${t(translationConstants.ARE_YOU_SURE_WANT_TO_CANCEL)} ${
        direction === Directions.rtl && competitionDataById?.arabicTitle
          ? `${competitionDataById?.arabicTitle}`
          : `${competitionDataById?.title}`
      } ${t(translationConstants.REGISTRATION)}`
    );
    dispatch(competitionActions.toggleViewModal(!isViewModal));
  };

  const navigateToLeaderboard = () => {
    navigate(`${viewPathConstants.COMPETITION_LEADERBOARD}`, {
      state: { competition: competitionDataById },
    });
  };

  useEffect(() => {
    dispatch(competitionActions.getPublicCompetitionById(competitionId));
  }, []);

  const icsCompetition = {
    title: competitionDataById?.title,
    description: competitionDataById?.description,
    startTime: moment(
      competitionDataById?.startDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    endTime: moment(
      competitionDataById?.endDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    location: `${competitionDataById?.spotInfo?.spotName}`,
  };

  return (
    <>
      <div className="container move-back">
        <span className="cursor-pointer" onClick={moveBack}>
          <img src={ArrowLeftIcon} className="rotated-element" />
        </span>
      </div>
      {competitionDataById && Object.keys(competitionDataById).length > 0 && (
        <div className="container">
          <Row className="detail-competition-wrapper">
            <Col sm={12} className="pb-4">
              {competitionDataById?.posters && (
                <img
                  alt="info-icon"
                  src={competitionDataById?.posters?.link}
                  className="w-100 poster-style"
                />
              )}
            </Col>
            <div className="row">
              <Col sm={12} md={12} lg={7} className="">
                <div className="mb-3">
                  <div className="d-flex flex-column gap-2">
                    <h3 className="fw-bolder">
                      {direction === Directions.rtl &&
                      competitionDataById?.arabicTitle
                        ? `${competitionDataById?.arabicTitle}`
                        : `${competitionDataById?.title}`}
                    </h3>
                  </div>
                  <div className="d-flex flex-column">
                    <h5 className="font-18 fw-bold">
                      {t(translationConstants[sportType])}
                    </h5>
                    <h5 className="font-16 text-muted">{classes}</h5>
                  </div>
                  <div className="d-flex flex-column">
                    <h5 className="font-16">
                      {toSingleDateStringIfEqual(
                        competitionDataById?.startDateString,
                        competitionDataById?.endDateString
                      )}
                    </h5>
                    <h5 className="font-16">
                      <img alt="" name="activityDate" src={TimeIcon} />
                      <span>
                        {formatDateTimeRangeFromServer(
                          competitionDataById?.startDateString,
                          competitionDataById?.endDateString,
                          timezoneConstants.hourMinuteFormat
                        )}
                      </span>
                    </h5>
                  </div>
                </div>
              </Col>
              <Col
                sm={12}
                md={12}
                lg={5}
                className="mb-3 mb-lg-0 d-flex gap-md-3 gap-2 align-items-start justify-content-lg-end"
              >
                <div className="d-flex align-items-md-center align-items-start justify-content-md-between flex-column">
                  <div className="seatsAvailableCard-light h-120px px-md-4 px-3 py-4 flex-grow-1 gap-2">
                    {!isCancelled ? (
                      <Button
                        className="registration-invite-only m-0"
                        disabled={true}
                      >
                        {t(translationConstants.CANCELLED)}
                      </Button>
                    ) : dateToUTCWithTimezone().isSameOrBefore(
                        serverFormatToMomentObject(
                          competitionDataById?.startDateString
                        )
                      ) ? (
                      <>
                        <Button
                          className="btn-cancel-outline m-0"
                          onClick={onDelete}
                        >
                          {competitionDataById?.isPublicRegistrationAllowed
                            ? t(
                                translationConstants.CANCEL_COMPETITION_REGISTRATION
                              )
                            : t(translationConstants.CANCEL_INVITE)}
                        </Button>
                      </>
                    ) : competitionDataById?.isScorePublished ? (
                      <Button
                        className="btn-submit m-0"
                        onClick={() => {
                          navigateToLeaderboard();
                        }}
                      >
                        {t(translationConstants.VIEW_RESULT)}
                      </Button>
                    ) : dateToUTCWithTimezone().isSameOrBefore(
                        serverFormatToMomentObject(
                          competitionDataById?.endDateString
                        )
                      ) ? (
                      <Button
                        className="registration-invite-only customBtnforCompetionInProgress m-0"
                        type="button"
                        disabled={true}
                      >
                        {t(translationConstants.COMPETITION_IN_PROGRESS)}
                      </Button>
                    ) : (
                      <Button
                        className="registration-invite-only m-0 customBtnforCompetionInProgress"
                        disabled={true}
                      >
                        {t(translationConstants.SCORE_NOT_PUBLISHED)}
                      </Button>
                    )}
                  </div>
                </div>
              </Col>
            </div>

            <div>
              <Row>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.LOCATION)}:
                    </h5>
                  </div>
                  <div>
                    <a
                      href={
                        competitionDataById?.spotInfo
                          ? undefined
                          : `https://maps.google.com/?q=${competitionDataById?.lat},${competitionDataById?.long}`
                      }
                      onClick={(e) => {
                        if (competitionDataById?.spotInfo) {
                          e.preventDefault(); // Prevent default link behavior
                          navigate(viewPathConstants.VIEW_SPOT_DETAIL, {
                            state: {
                              centerId: competitionDataById?.spotInfo?.id,
                            },
                          });
                        }
                      }}
                      target="_blank"
                      className="font-16 center-card-view-detail-link"
                    >
                      <img src={DirectionIcon} alt="get directions icon" />
                      {direction === Directions.rtl
                        ? competitionDataById?.spotInfo?.arabicSpotName ||
                          competitionDataById?.spotInfo?.spotName
                        : competitionDataById?.spotInfo?.spotName}
                      {direction === Directions.rtl
                        ? city?.arabicName || city?.name
                        : city?.name}
                    </a>
                  </div>
                </Col>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h6 className="font-18 fw-bolder">
                      {t(translationConstants.AGE_LIMIT)}:
                    </h6>
                  </div>
                  <div>
                    <p className="font-16">{` ${
                      competitionDataById?.minAge
                    } - ${competitionDataById?.maxAge} ${t(
                      translationConstants.YEARS
                    )}`}</p>
                  </div>
                </Col>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.important_documents)}:
                    </h5>
                  </div>
                  <div>
                    <a
                      href={competitionDataById?.nor?.link}
                      target="_blank"
                      className="font-16 underline"
                    >
                      {t(translationConstants.NOTICE_OF_RACE)}
                    </a>
                  </div>
                </Col>
              </Row>
              <Col sm={12} md="auto">
                {competitionDataById?.providedServices && (
                  <div>
                    <h6 className="font-18 fw-bolder">
                      {t(translationConstants.SERVICES)}
                    </h6>
                    <p className="font-16 w-75">
                      {CommaSplitToTranslatedCommaJoined(
                        competitionDataById?.providedServices,
                        t
                      )}
                    </p>
                  </div>
                )}
              </Col>

              {competitionDataById?.description && (
                <div className="py-4 d-flex flex-column gap-2">
                  <span className="second-card-heading-text">
                    {t(translationConstants.DESCRIPTION)}
                  </span>
                  <span className="second-card-description-text w-75 text-break">
                    {direction === systemConstants.DIRECTION_RIGHT_TO_LEFT &&
                    competitionDataById?.arabicDescription
                      ? competitionDataById?.arabicDescription
                      : competitionDataById?.description}
                  </span>
                </div>
              )}

              <div className="mt-20px">
                {competitionDataById?.isPublicRegistrationAllowed && (
                  <a
                    target="_blank"
                    disabled={true}
                    className="d-none font-14 underline center-card-view-detail-link approved-color cursor-not-allowed"
                  >
                    {t(translationConstants.VIEW_CANCELLATION_POLICY)}
                  </a>
                )}

                <div>
                  <span
                    target="_blank"
                    disabled={true}
                    className="font-14 center-card-view-detail-link approved-color"
                  >
                    <ICalendarLink
                      event={icsCompetition}
                      filename={competitionDataById?.title}
                    >
                      {t(translationConstants.add_to_calendar)}
                    </ICalendarLink>
                  </span>
                </div>
              </div>
            </div>

            <CustomModal
              scrollable={true}
              size="md"
              setShow={onDelete}
              show={isViewModal}
              customClass="view-user-modal"
            >
              <DeleteModal
                title={title}
                message={message}
                removeRowData={cancellationData}
                onCancel={() => onDelete()}
              />
            </CustomModal>
          </Row>
        </div>
      )}
    </>
  );
};

export default DetailCompetition;
